export class FileBlobPromises {
  public static readAsDataURL(blob: Blob, progress?: (percentage: number) => void): Promise<string> {
    return new Promise<string>((ok, fail) => {
      const reader = FileBlobPromises.createFileReader(fail, progress);
      reader.onloadend = () => {
        ok(reader.result as string);
      };

      reader.readAsDataURL(blob);
    });
  }

  public static readAsArrayBuffer(blob: Blob, progress?: (percentage: number) => void): Promise<ArrayBuffer> {
    return new Promise<ArrayBuffer>((ok, fail) => {
      const reader = FileBlobPromises.createFileReader(fail, progress);
      reader.onloadend = (evt) => {
        if (evt.target["readyState"] === 2) { // DONE == 2
          ok(evt.target["result"] as ArrayBuffer);
        }
      };

      reader.readAsArrayBuffer(blob);
    });
  }

  private static createFileReader(fail: (msg: string) => void, progress?: (percentage: number) => void) {
    const reader = new FileReader();
    reader.onerror = e => {
      const msg = this.errorMessage(e);
      if (msg) {
        fail(msg);
      }
    };

    reader.onabort = () => {
      fail("File read cancelled");
    };

    if (progress) {
      reader.onprogress = (evt: ProgressEvent) => {
        if (evt.lengthComputable) {
          progress(Math.round((evt.loaded / evt.total) * 100));
        }
      };
      reader.onloadstart = (e) => {
        progress(0);
      };
      reader.onload = (e) => {
        progress(100);
      };
    }

    return reader;
  }

  private static errorMessage(evt) {
    const err = evt.target.error;
    switch (err.code) {
      case err.NOT_FOUND_ERR:
        return "Unable to Read - File Not Found!";
      case err.NOT_READABLE_ERR:
        return "File is not readable";
      case err.ABORT_ERR:
        return null;
      default:
        return "An error occurred reading this file.";
    }
  }
}
